import is from 'is_js';

export const DefaultPaperbasedHomeworkStatus = 'unmarked';

export const PaperbasedHomeworkStatus = {
  complete: 'Complete',
  incomplete: 'Incomplete',
  unmarked: 'UnMarked',
  notapplicable: 'NotApplicable',
  partialcomplete: 'PartialComplete',
};

export const PaperbasedHomeworkStatusBackendNames = {
  complete: PaperbasedHomeworkStatus.complete,
  incomplete: PaperbasedHomeworkStatus.incomplete,
  unmarked: PaperbasedHomeworkStatus.unmarked,
  partialcomplete: PaperbasedHomeworkStatus.partialcomplete,
  notapplicable: PaperbasedHomeworkStatus.notapplicable,
};

export const PaperbasedHomeworkStatusColorMappins = {
  [PaperbasedHomeworkStatus.complete]: 'green',
  [PaperbasedHomeworkStatus.incomplete]: 'red',
  [PaperbasedHomeworkStatus.partialcomplete]: 'amber',
};

export function covertBackendPaperBasedHomeworkStatusToHomeworkStatus(
  backendPaperBasedHomeworkStatus, isMarking) {
  const backendStatusLower = is.string(backendPaperBasedHomeworkStatus) ?
      backendPaperBasedHomeworkStatus.toLowerCase() :
        null;
  if (isMarking &&
      (! backendPaperBasedHomeworkStatus ||
          PaperbasedHomeworkStatusBackendNames[backendStatusLower] ===
          PaperbasedHomeworkStatus.unmarked)) {
    return PaperbasedHomeworkStatus.complete;
  }
  return PaperbasedHomeworkStatusBackendNames[backendStatusLower] ||
      PaperbasedHomeworkStatus.unmarked;
}

export function validateHomeworkStatus(status) {
  if (PaperbasedHomeworkStatus[status]) {
    return true;
  }
  throw new Error(`Status "${status}" is not valid! Use the Status object provided`);
}



// WEBPACK FOOTER //
// ./data/PaperBasedHomework/status.js